<template>
    <div class="row mb-3">
      <h4>Projected ROI</h4>
      <div class="col-7">
        <div class="card h-100 p-2">
          <div class="d-flex flex-row gap-2">
            Emails
              <div class="d-flex justify-content-center align-items-center">
                <label class="form-label mb-0">{{ Math.round(projection.emails.min) }}</label>
              </div>
              <div class="flex-grow-1 mx-2" :class="(projection.emails.value < 0 ? 'negative' : '')">
                  <VueSlider
                    class="single-color-slider"
                    v-model="projection.emails.value"
                    :tooltip-formatter="val => val"
                    :min="projection.emails.min"
                    :max="projection.emails.max"
                    :interval="1"
                    :dot-attrs="{ 'aria-label': 'Emails projection' }"
                    @dragStart="projection.emails.dragging=true"
                    @dragEnd="dragEndForEmails"
                    @change="changeEmails"
                    :tooltip="'always'"
                  />
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <label class="form-label mb-0">{{ Math.round(projection.emails.max) }}</label>
              </div>
          </div>
          <div class="d-flex flex-row gap-2">
            Ad Spend
              <div class="d-flex justify-content-center align-items-center">
                <label class="form-label mb-0">{{ Math.round(projection.ad_spend.min) }}</label>
              </div>
              <div class="flex-grow-1 mx-2" :class="(projection.ad_spend.value < 0 ? 'negative' : '')">
                  <VueSlider
                    class="single-color-slider"
                    v-model="projection.ad_spend.value"
                    :tooltip-formatter="val => val"
                    :min="projection.ad_spend.min"
                    :max="projection.ad_spend.max"
                    :interval="1"
                    :dot-attrs="{ 'aria-label': 'Ad spend projection' }"
                    @dragStart="projection.ad_spend.dragging=true"
                    @dragEnd="dragEndForAdSpend"
                    @change="changeAdSpend"
                    :tooltip="'always'"
                  />
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <label class="form-label mb-0">{{ Math.round(projection.emails.max) }}</label>
              </div>
          </div>
        </div>
      </div>

      <div class="col-5">
        <div class="card h-100 p-2">
          <p>Revenue: {{ currency_with_zero(projection.outcomes.revenue) }}</p>
          <p>Donors: {{ number_with_zero(projection.outcomes.donors) }}</p>
        </div>
      </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import VueSlider from 'vue-3-slider-component'

export default defineComponent({
  name: 'PlaybookDescriptionProjection',
  components: {
    VueSlider
  },
  props: {
    // Add props if needed
  },
  data() {
    return {
      projection: {
        emails: {
          min: 0,
          max: 100,
          value: 50,
          dragging: false
        },
        ad_spend: {
          min: 0,
          max: 100,
          value: 50,
          dragging: false
        },
        outcomes: {
          revenue: 506815,
          donors: 10000
        }
      }
    }
  },
  beforeMount() {
    // Add any initialization logic if needed
  },
  methods: {
    changeEmails() {
      if (!this.projection.emails.dragging) {
        // this.$emit('input', this.local_value);
        // this.$emit('change', this.local_value);
      }
    },
    dragEndForEmails() {
      // this.$emit('change', this.local_value);
      this.projection.emails.dragging = false
    },
    changeAdSpend() {
      if (!this.projection.ad_spend.dragging) {
        // this.$emit('input', this.local_value);
        // this.$emit('change', this.local_value);
      }
    },
    dragEndForAdSpend() {
      // this.$emit('change', this.local_value);
      this.projection.ad_spend.dragging = false
    }
  }
})
</script>
